import { trackingEnvironment } from './useVirtualPageViews.js'

const enrichDataWithDeviceInfo = (data: object): object => ({
  ...data,
  trackingEnvironment: trackingEnvironment(),
})

export const pushDataToGtm = (data: object, isGtmEnabled: boolean): void => {
  if (isGtmEnabled && data) {
    window.dataLayer?.push(enrichDataWithDeviceInfo(data))
  }
}
